const $ = jQuery

export default class NavSearch {
  ready () {
    this.SEARCH_ICON = document.getElementById('navigation-search')
    this.SEARCH_WRAP = document.getElementById('navigation-search-wrap')

    this.cls = 'nav-search-wrap--open'

    if (!this.SEARCH_ICON || !this.SEARCH_WRAP) {
      return
    }

    this.INPUT = this.SEARCH_WRAP.querySelector('input')
    this.INPUT_BUTTON = this.SEARCH_WRAP.querySelector('button')

    this.eventListeners()
  }

  eventListeners () {
    // click on icon
    this.SEARCH_ICON.addEventListener('click', this.toggleSearch.bind(this))
    this.SEARCH_ICON.addEventListener('keydown', () => this.handleEnter(event.keyCode))

    // close on escape
    window.addEventListener('keydown', (e) => {
      event.keyCode === 27 ? this.closeSearch() : ''
    })

    // close on scroll
    window.addEventListener('scroll', this.closeSearch.bind(this))
  }

  handleEnter (keyCode) {
    if (keyCode === 13) {
      event.preventDefault()
      this.openSearch()
    }
  }

  toggleSearch () {
    this.SEARCH_WRAP.classList.contains(this.cls) ? this.closeSearch() : this.openSearch()
  }

  openSearch () {
    this.SEARCH_WRAP.classList.add(this.cls)

    if (this.INPUT) {
      this.INPUT.setAttribute('tabindex', '0')
      this.INPUT_BUTTON.setAttribute('tabindex', '0')
      this.INPUT.focus()
    }
  }

  closeSearch () {
    this.SEARCH_WRAP.classList.remove(this.cls)
    this.INPUT.setAttribute('tabindex', '-1')
    this.INPUT_BUTTON.setAttribute('tabindex', '-1')
  }
}
